// Mock data for RSP Innov — AI-First positioning

export const brand = {
  logo: "/logo.png",
  primary: "#73100D",
  primaryDark: "#5E0000",
  accent: "#98413F",
  silver: "#E5E5E5",
  ink: "#1a1a1a",
};

export const navLinks = [
  { name: "Home", href: "#home" },
  { name: "AI Solutions", href: "#ai" },
  { name: "Services", href: "#services" },
  { name: "Journey", href: "#expertise" },
  { name: "Clients", href: "#clients" },
  { name: "Contact", href: "#contact" },
];

export const heroData = {
  tagline: "AI • Automation • Enterprise Software",
  title: "Automate your business.",
  highlight: "Amplify revenue.",
  description:
    "RSP Innovations builds Agentic AI, intelligent automation and custom enterprise software that turns manual processes into measurable business growth.",
  primaryCta: "Book a Strategy Call",
  secondaryCta: "Explore AI Solutions",
  rotating: ["Agentic AI", "Process Automation", "Custom Software", "Cloud Platforms", "Data Intelligence"],
  trust: [
    { k: "85+", v: "Enterprise Clients" },
    { k: "43+", v: "AI Deployments" },
    { k: "40%", v: "Avg. Cost Reduction" },
  ],
};

export const aiCapabilities = [
  {
    icon: "Bot",
    title: "Agentic AI Agents",
    desc: "Autonomous AI agents that reason, plan and execute multi-step business workflows without human supervision.",
    metric: "24/7 execution",
  },
  {
    icon: "Workflow",
    title: "Intelligent Automation",
    desc: "Replace repetitive manual work with RPA + LLM hybrid pipelines tuned to your specific operations.",
    metric: "60% time saved",
  },
  {
    icon: "BrainCircuit",
    title: "Custom AI Models",
    desc: "Fine-tuned LLMs, RAG systems and computer vision pipelines built around your proprietary data.",
    metric: "Domain-trained",
  },
  {
    icon: "BarChart3",
    title: "Predictive Analytics",
    desc: "Forecast demand, churn and revenue with ML models embedded into dashboards your team already uses.",
    metric: "94% accuracy",
  },
];

export const aboutData = {
  pill: "About RSPInnov LLP",
  title: "The",
  highlight: "Right Solution Path",
  titleTail: "to AI-driven growth",
  subtitle: "Established 2016 • AI · Automation · Enterprise Software",
  description:
    "RSPInnov LLP is a Bangalore-based software development and technology services company serving large enterprises and SMEs across IT/ITES, Healthcare, Finance, Fashion, Jewelry, Fitness, Retail, Consumer Goods and Electronics. From Agentic AI deployments and managed capacity to bespoke software platforms, our engineering teams deliver measurable business outcomes.",
  pillars: [
    { title: "AI-first thinking", desc: "Every engagement starts with an automation opportunity assessment and a measurable ROI target." },
    { title: "Enterprise-grade delivery", desc: "Production-ready code, observability and security baked into every system we ship." },
  ],
  missionVision: {
    mission: "To unify the dreams through diversified efforts.",
    vision: "Innovative solutions towards the right direction.",
  },
};

export const stats = [
  { value: 43, suffix: "+", label: "AI Deployments" },
  { value: 85, suffix: "+", label: "Enterprise Clients" },
  { value: 40, suffix: "%", label: "Avg Cost Reduction" },
  { value: 98, suffix: "%", label: "Client Satisfaction" },
];

export const services = [
  { id: 1, icon: "Bot", title: "Agentic AI Solutions", desc: "Autonomous AI agents that reason, plan and execute end-to-end business workflows." },
  { id: 2, icon: "Workflow", title: "Process Automation", desc: "Replace repetitive operations with intelligent RPA + LLM hybrid pipelines." },
  { id: 3, icon: "Code2", title: "Custom Software", desc: "Tailor-made enterprise platforms built with modern, proven technology stacks." },
  { id: 4, icon: "Globe", title: "Web Development", desc: "High-conversion web platforms engineered for speed, scale and SEO excellence." },
  { id: 5, icon: "Smartphone", title: "Mobile Applications", desc: "Native iOS, Android and cross-platform apps that delight at every touchpoint." },
  { id: 6, icon: "Cloud", title: "Cloud & DevOps", desc: "AWS, Azure and GCP architectures with containerized CI/CD and observability." },
  { id: 7, icon: "Database", title: "SAP / ABAP", desc: "Enterprise SAP implementations, ABAP development and HANA integrations." },
  { id: 8, icon: "BarChart3", title: "Data & Analytics", desc: "Data pipelines, BI dashboards and predictive models powering smart decisions." },
  { id: 9, icon: "Users", title: "Employee on Contract (C2H)", desc: "Skilled talent on Contract & Contract-to-Hire across SAP, Microsoft, Cloud, AI and full-stack roles — flexible engagement, fast onboarding." },
];

// Domestic & Global clients sourced from RSP company profile (logos to be swapped later)
export const clients = [
  { name: "Wipro", region: "domestic" },
  { name: "Clikodoc", region: "domestic" },
  { name: "Arham Jewels", region: "domestic" },
  { name: "SGM Consultancy", region: "domestic" },
  { name: "Terracarb", region: "domestic" },
  { name: "Oye Desi", region: "domestic" },
  { name: "BizKard", region: "domestic" },
  { name: "Solitaire Diamond Institute", region: "domestic" },
  { name: "TurtleTec", region: "domestic" },
  { name: "Sands Advance Ceramics", region: "domestic" },
  { name: "Ganesh Diamonds", region: "domestic" },
  { name: "Carbon Facet", region: "domestic" },
  { name: "Prism Eye Care", region: "domestic" },
  { name: "Sujal Pharma", region: "domestic" },
  { name: "Dyne Foods", region: "domestic" },
  { name: "Gigls", region: "domestic" },
  { name: "Jewel Jobs", region: "domestic" },
  { name: "Facturozor", region: "global" },
  { name: "Healthplanner", region: "global" },
  { name: "Yoga Life West Indies", region: "global" },
  { name: "Utellme", region: "global" },
  { name: "Evig Community Bridge", region: "global" },
  { name: "Anchor", region: "global" },
];

export const testimonials = [
  { id: 1, name: "Guillian & Rodolphe", role: "Hospice Consulting, Martinique", avatar: "https://i.pravatar.cc/120?img=12",
    text: "Outstanding quality/cost ratio and on-time delivery. The RSP team accommodated our time differences and delivered exactly what we needed without delay." },
  { id: 2, name: "Anamika S.", role: "AGENXT FASHIONS", avatar: "https://i.pravatar.cc/120?img=47",
    text: "RSP's software solutions helped our business reach a wider market. Their round-the-clock support enabled us to Go-Live in a very short span of time." },
  { id: 3, name: "Marcus Chen", role: "TechWave Solutions", avatar: "https://i.pravatar.cc/120?img=33",
    text: "Their expertise in AI agents and cloud architecture transformed our internal operations. A genuinely strategic long-term technology partner." },
];

export const expertise = [
  { name: "Mobile", year: "2016", title: "Native & Cross-Platform Mobile Apps", desc: "React Native, Flutter and native iOS/Android. Resilient mobile experiences with native performance." },
  { name: "Web", year: "2017", title: "Modern Web Platforms", desc: "Laravel, Node.js and React platforms engineered for performance and conversion." },
  { name: "Microsoft", year: "2018", title: "Microsoft Enterprise Stack", desc: ".NET, ASP.NET Core, SQL Server and Azure deployments tailored to enterprise operations." },
  { name: "Cloud", year: "2019", title: "Cloud-Native Architecture", desc: "AWS, Azure and GCP. Containerized, scalable and observable systems by design." },
  { name: "UI / UX", year: "2020", title: "Human-Centered Design", desc: "Wireframes, design systems and pixel-perfect interfaces that convert visitors into customers." },
  { name: "Java", year: "2021", title: "Enterprise Java Engineering", desc: "Spring Boot microservices, Kafka streams and reactive systems with low-latency throughput." },
  { name: "SAP", year: "2022", title: "SAP / ABAP Specialists", desc: "ABAP, Fiori apps and HANA integrations bridging legacy ERP with modern interfaces." },
  { name: "C2H", year: "2023", title: "Contract & Contract-to-Hire (C2H)", desc: "Skilled talent on flexible engagements across SAP, Microsoft, Cloud, AI and full-stack roles — fast onboarding, zero overhead." },
  { name: "AI", year: "2024", title: "Agentic AI & Automation", desc: "LLM agents, RAG systems and computer vision embedded directly into business workflows." },
];

export const techStack = [
  { name: "React", logo: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/react/react-original.svg" },
  { name: "Python", logo: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/python/python-original.svg" },
  { name: "TensorFlow", logo: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/tensorflow/tensorflow-original.svg" },
  { name: "PyTorch", logo: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/pytorch/pytorch-original.svg" },
  { name: "Node.js", logo: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/nodejs/nodejs-original.svg" },
  { name: "AWS", logo: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/amazonwebservices/amazonwebservices-plain-wordmark.svg" },
  { name: "Azure", logo: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/azure/azure-original.svg" },
  { name: "Docker", logo: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/docker/docker-original.svg" },
  { name: "Kubernetes", logo: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/kubernetes/kubernetes-plain.svg" },
  { name: "MongoDB", logo: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/mongodb/mongodb-original.svg" },
  { name: "PostgreSQL", logo: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/postgresql/postgresql-original.svg" },
  { name: "Kafka", logo: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/apachekafka/apachekafka-original.svg" },
  { name: "Redis", logo: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/redis/redis-original.svg" },
  { name: "GraphQL", logo: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/graphql/graphql-plain.svg" },
  { name: "Java", logo: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/java/java-original.svg" },
  { name: "SAP", logo: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/microsoftsqlserver/microsoftsqlserver-plain.svg" },
  { name: "Angular", logo: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/angularjs/angularjs-original.svg" },
  { name: "TypeScript", logo: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/typescript/typescript-original.svg" },
  { name: "Terraform", logo: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/terraform/terraform-original.svg" },
  { name: "GitHub", logo: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/github/github-original.svg" },
];

export const contactCta = {
  pill: "Let's automate",
  title: "Ready to Automate Your Business and",
  highlight: "Increase Revenue?",
  description:
    "Transform manual processes into intelligent workflows with AI, automation, custom software and digital solutions designed to improve efficiency, reduce costs and accelerate business growth.",
};

export const footerData = {
  company: "RSPInnov LLP",
  tagline: "Right Solution Path",
  description:
    "RSP Innovations is the right solution path to AI-driven business growth. We engineer Agentic AI, automation and enterprise software that delivers measurable outcomes.",
  social: [
    { name: "Facebook", icon: "Facebook", href: "#" },
    { name: "Twitter", icon: "Twitter", href: "#" },
    { name: "LinkedIn", icon: "Linkedin", href: "#" },
    { name: "Instagram", icon: "Instagram", href: "#" },
  ],
  contact: {
    email: "management@rspinnovations.com",
    phone: "+91 98863 35516",
    address: "#711, 3rd Cross Road, Hanumanth Nagar, Banashankari 1st Stage, Bengaluru – 560050, Karnataka, India",
    website: "www.rspinnovations.com",
  },
};
